export default __webpack_public_path__ + "locales/hy-AM/HotkeysPanel.json?hash=8bcff98665d026d287ee5a1d257e75ed";